export enum RequestorFillTypeRestriction {
  NONE,
  MANUAL,
  AUTO,
}

export namespace RequestorFillTypeRestriction {
  let elements = [
    RequestorFillTypeRestriction.NONE,
    RequestorFillTypeRestriction.MANUAL,
    RequestorFillTypeRestriction.AUTO,
  ];
  let alias = "com.bcdfx.model.RequestorFillTypeRestriction";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
